<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h1 class="text-2xl font-bold mb-4">Riepilogo Presenze</h1>
                
                <TabView>
                    <TabPanel header="Atleti">
                        <AttendanceSummaryTable :data="athleteData" type="athlete" @cell-click="showDetails" @header-click="showGlobalDetails" />
                    </TabPanel>
                    <TabPanel header="Staff">
                        <AttendanceSummaryTable :data="staffData" type="staff" @cell-click="showDetails" @header-click="showGlobalDetails" />
                    </TabPanel>
                </TabView>
            </div>
        </div>
        
        <Dialog v-model:visible="detailsVisible" :header="detailsHeader" :modal="true" :style="{width: '60vw'}" :breakpoints="{'960px': '75vw', '640px': '90vw'}">
            <DataTable v-if="detailsData" :value="detailsData" :paginator="true" :rows="10" class="p-datatable-sm">
                <Column field="data_inizio" header="Data">
                    <template #body="{data}">
                        {{ formatDate(data.data_inizio) }}
                    </template>
                </Column>
                <Column field="data_inizio" header="Ora Inizio">
                    <template #body="{data}">
                        {{ formatTime(data.data_inizio) }}
                    </template>
                </Column>
                <Column field="data_fine" header="Ora Fine">
                    <template #body="{data}">
                        {{ formatTime(data.data_fine) }}
                    </template>
                </Column>
                <Column v-if="detailsType === 'athlete'" field="presenze" header="Presenze"></Column>
                <Column v-if="detailsType === 'athlete' && isGlobalDetail" field="corso_nome" header="Corso"></Column>
                <Column v-if="detailsType === 'staff'" field="corso_nome" header="Corso"></Column>
                <Column v-if="detailsType === 'staff' && isGlobalDetail" field="staff_nome" header="Staff"></Column>
                <Column v-if="detailsType === 'staff'" field="status" header="Stato">
                    <template #body="{data}">
                        <span :class="getStatusClass(data.status)">{{ data.status }}</span>
                    </template>
                </Column>
            </DataTable>
        </Dialog>
    </div>
</template>

<script>
import { ref, onMounted, getCurrentInstance } from 'vue';
import Service from '@/services/levante-api/levante-api';
import AttendanceSummaryTable from '@/components/AttendanceSummaryTable.vue';
import moment from 'moment';

export default {
    name: 'AttendanceSummary',
    components: {
        AttendanceSummaryTable
    },
    setup() {
        const self = getCurrentInstance();
        if (self.appContext.config.globalProperties.$eventBus) {
             self.$eventBus = self.appContext.config.globalProperties.$eventBus;
        }
        
        const service = new Service(self.$eventBus);
        
        const athleteData = ref([]);
        const staffData = ref({});
        
        const detailsVisible = ref(false);
        const detailsData = ref([]);
        const detailsHeader = ref('');
        const detailsType = ref('');
        const isGlobalDetail = ref(false);
        
        const loadData = async () => {
            try {
                const athleteRes = await service.getAthleteAttendanceSummary();
                if (athleteRes.items) {
                    athleteData.value = athleteRes.items;
                } else if (Array.isArray(athleteRes)) {
                     athleteData.value = athleteRes;
                }
                
                const staffRes = await service.getStaffAttendanceSummary();
                if (staffRes.items) {
                    staffData.value = staffRes.items;
                } else if (staffRes.assigned) {
                    staffData.value = staffRes;
                }
            } catch (error) {
                console.error("Error loading attendance data", error);
            }
        };
        
        const showDetails = async (event) => {
            isGlobalDetail.value = false;
            detailsType.value = event.type;
            detailsHeader.value = `Dettaglio ${event.name} - ${event.month}/${event.year}`;
            detailsData.value = [];
            detailsVisible.value = true;
            
            console.log("event", event);
            try {
                let res;
                if (event.type === 'athlete') {
                    res = await service.getAthleteAttendanceDetails({
                        id: event.id,
                        month: event.month,
                        year: event.year
                    });
                } else {
                    res = await service.getStaffAttendanceDetails({
                        id: event.id,
                        month: event.month,
                        year: event.year
                    });
                }
                
                if (res) {
                    detailsData.value = res.items || res;
                    console.log("res", res);
                    console.log("detailsData", detailsData.value);
                }
            } catch (error) {
                console.error("Error loading details", error);
            }
        };

        const showGlobalDetails = async (event) => {
            isGlobalDetail.value = true;
            detailsType.value = event.type;
            detailsHeader.value = `Riepilogo Mensile ${event.type === 'athlete' ? 'Atleti' : 'Staff'} - ${event.month}/${event.year}`;
            detailsData.value = [];
            detailsVisible.value = true;
            
            try {
                let res;
                if (event.type === 'athlete') {
                    res = await service.getAthleteAttendanceDetails({
                        month: event.month,
                        year: event.year
                    });
                } else {
                    res = await service.getStaffAttendanceDetails({
                        month: event.month,
                        year: event.year
                    });
                }
                
                if (res) {
                    detailsData.value = res.items || res;
                }
            } catch (error) {
                console.error("Error loading global details", error);
            }
        };
        
        const formatDate = (date) => {
            return moment(date).format('DD/MM/YYYY');
        };
        
        const formatTime = (date) => {
            return moment(date).format('HH:mm');
        };
        
        const getStatusClass = (status) => {
            if (status === 'Presente') return 'text-green-500 font-bold';
            if (status === 'Assente') return 'text-red-500 font-bold';
            if (status === 'Sostituzione') return 'text-blue-500 font-bold';
            return '';
        };
        
        onMounted(() => {
            loadData();
        });
        
        return {
            athleteData,
            staffData,
            detailsVisible,
            detailsData,
            detailsHeader,
            detailsType,
            isGlobalDetail,
            showDetails,
            showGlobalDetails,
            formatDate,
            formatTime,
            getStatusClass
        };
    }
}
</script>
